import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from 'material/components/Grid';

const StyledGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  margin-top: ${props => props.margintop}px;
  margin-bottom: ${props => props.marginbottom}px;
`;

/**
 * Centered page column — wrap every page body in it. Renders children in a
 * 10/12-column grid on large screens (11/12 below) centered within the
 * viewport.
 */
const Container = ({ children, className, marginBottom, marginTop }) => (
  <Grid
    className={className}
    container
    sx={{
      height: '100%',
      justifyContent: 'center',
      width: '100%',
    }}
  >
    <StyledGrid
      size={{
        lg: 10,
        xs: 11,
      }}
      marginbottom={marginBottom}
      margintop={marginTop}
    >
      {children}
    </StyledGrid>
  </Grid>
);

Container.defaultProps = {
  className: '',
  marginBottom: '0',
  marginTop: '0',
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  marginBottom: PropTypes.string,
  marginTop: PropTypes.string,
};

export default Container;
